import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'

interface SoundControlModel {
  muted: boolean
  volume: number
}

const initialState: SoundControlModel = {
  muted: false,
  volume: 1,
}

const SoundControlSlice = createSlice({
  name: 'sound-control',
  initialState,
  reducers: {
    setMute: (state, { payload }: PayloadAction<boolean>) => ({ ...state, muted: payload }),
    setVolume: (state, { payload }: PayloadAction<number>) => {
      const volume = payload > 1 ? 1 : payload < 0 ? 0 : payload
      return { ...state, volume }
    },
  },
})

export const selectMuted = (state: RootState): SoundControlModel['muted'] => {
  return state.soundControl.muted
}

export const selectVolume = (state: RootState): SoundControlModel['volume'] => {
  return state.soundControl.volume
}

export const { setMute, setVolume } = SoundControlSlice.actions

export default SoundControlSlice.reducer
